
  (function($, Formstone) {
    var $window,
        $body,
        opts = {};

    opts.minXS = parseInt("320", 10);
    opts.minSM = parseInt("500", 10);
    opts.minMD = parseInt("740", 10);
    opts.minLG = parseInt("980", 10);
    opts.minXL = parseInt("1220", 10);

    opts.maxXS = opts.minXS - 1;
    opts.maxSM = opts.minSM - 1;
    opts.maxMD = opts.minMD - 1;
    opts.maxLG = opts.minLG - 1;
    opts.maxXL = opts.minXL - 1;

    opts.minHTsm = parseInt("500", 10);
    opts.minHT   = parseInt("800", 10);

    opts.maxHTsm = opts.minHTsm - 1;
    opts.maxHT   = opts.minHT - 1;

    Formstone.Ready(function(){
		$("a[data-lightbox-gallery]").lightbox({
			fixed: true,
			viewer: true
		});
	});

  })(jQuery, Formstone);



